module.exports = __webpack_public_path__ + "static/media/nav-icon-reports.62e5d63b.svg";